import React from "react";
import { ArrowUpRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/j1kstteb_PHOTO-2026-05-18-20-50-29.jpg";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 lg:pt-44 pb-24 lg:pb-32 overflow-hidden"
    >
      <div className="container mx-auto px-6 lg:px-10 relative">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 items-end">
          {/* Left: Editorial copy */}
          <div className="col-span-12 lg:col-span-8">
            <p className="eyebrow mb-6" data-testid="hero-eyebrow">
              Personal Brand & Growth Studio · Est. 2025
            </p>

            <h1
              data-testid="hero-headline"
              className="font-display tracking-editorial text-[var(--lt-charcoal)] leading-[0.95]"
              style={{ fontSize: "clamp(2.4rem, 6.8vw, 6rem)", fontWeight: 600 }}
            >
              Where{" "}
              <em className="italic font-normal text-[var(--lt-bark)] whitespace-nowrap">
                Little Things
              </em>
              <br />
              compound into
              <br />
              <span className="text-[var(--lt-charcoal)] whitespace-nowrap">Big Things.</span>
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-10 max-w-xl text-[var(--lt-bark)] text-base lg:text-lg leading-relaxed"
            >
              We build influential personal brands for founders, executives and category
              defining companies. Strategy, content, distribution. The small, deliberate
              moves that turn attention into authority.
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-book"
                className="inline-flex items-center gap-2 bg-[var(--lt-charcoal)] text-[var(--lt-peace)] px-7 py-4 text-xs uppercase tracking-[0.24em] hover:bg-[var(--lt-bark)] transition-colors duration-300"
              >
                Book a Discovery Call
                <ArrowUpRight size={16} />
              </a>
              <a
                href="#work"
                data-testid="hero-cta-work"
                className="inline-flex items-center gap-2 border border-[var(--lt-charcoal)]/70 text-[var(--lt-charcoal)] px-7 py-4 text-xs uppercase tracking-[0.24em] hover:bg-[var(--lt-charcoal)] hover:text-[var(--lt-peace)] transition-all duration-300"
              >
                See Our Work
              </a>
            </div>
          </div>

          {/* Right: Brand mark illustration — tree with roots = growth */}
          <div className="hidden lg:flex col-span-12 lg:col-span-4 justify-end">
            <div className="flex flex-col gap-6 max-w-[280px]">
              <div
                data-testid="hero-mark"
                className="aspect-square bg-[var(--lt-cream)] border border-[var(--lt-line)] grid place-items-center p-8"
              >
                <svg
                  viewBox="0 0 200 200"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  className="w-full h-full"
                >
                  {/* arched border */}
                  <ellipse
                    cx="100"
                    cy="100"
                    rx="78"
                    ry="92"
                    stroke="#D3B89D"
                    strokeWidth="2"
                  />
                  {/* canopy */}
                  <g fill="#AAA98E" opacity="0.95">
                    <circle cx="100" cy="62" r="22" />
                    <circle cx="78" cy="70" r="16" />
                    <circle cx="122" cy="70" r="16" />
                    <circle cx="86" cy="50" r="12" />
                    <circle cx="114" cy="50" r="12" />
                    <circle cx="100" cy="42" r="10" />
                    <circle cx="68" cy="82" r="11" />
                    <circle cx="132" cy="82" r="11" />
                  </g>
                  {/* trunk + stepped base */}
                  <path
                    d="M97 90 L97 116 L88 116 L88 124 L80 124 L80 132 L120 132 L120 124 L112 124 L112 116 L103 116 L103 90 Z"
                    fill="#AAA98E"
                  />
                  {/* roots */}
                  <g
                    stroke="#AAA98E"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    fill="none"
                  >
                    <path d="M100 132 C 92 142 84 150 72 156" />
                    <path d="M100 132 C 108 142 116 150 128 156" />
                    <path d="M100 132 C 96 146 92 156 86 168" />
                    <path d="M100 132 C 104 146 108 156 114 168" />
                    <path d="M100 132 C 100 148 100 162 100 174" />
                    <path d="M86 168 C 80 172 74 174 68 176" />
                    <path d="M114 168 C 120 172 126 174 132 176" />
                  </g>
                </svg>
              </div>
              <div className="border-t border-[var(--lt-line)] pt-4">
                <p className="font-body text-xs tracking-[0.18em] uppercase text-[var(--lt-bark)] mb-2">
                  Because
                </p>
                <p className="font-display italic text-xl text-[var(--lt-charcoal)] leading-snug">
                  Big Things are built on Little Things.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

